module.exports = __webpack_public_path__ + "static/media/user-placeholder.b832b06d.svg";